// The selection, and its one home (PLAN-UI §28.3, U6).
//
// Reads `SessionView.inspector` and hands every click back as an option
// (PLAN-CLIENT-SPLIT day 8). What the selection is, which controls it carries
// and why any is off are the engine's to say — and so is when there is no card
// at all: **nothing about the selection is drawn while anything is armed**, so
// the view is null then, and null for bare ground, which has nothing to say.

import { GroundCard } from "../GroundCard";
import { Inspector } from "../Inspector";
import { useSession, useSessionView } from "../useSessionView";

export function InspectorZone(_props: {
  /** The old interaction bag; ignored since day 8 and kept for the shell's line. */
  board_?: unknown;
}) {
  const session = useSession();
  const { inspector } = useSessionView();

  /* **The selection has one home, and it is one card** (PLAN-UI §28.3, U6;
     designer rulings, U6 reviews). The inspector reads the piece out, carries
     the controls in a row under the readouts, and draws every dense section
     under that. `ActionBar.tsx` went at the first review — a bar floating over
     the board covered the squares it was about and re-projected on every frame
     the camera moved — and `ContextPopover.tsx` at the second: a `···` door in
     front of a store's taps is a click for nothing. The shelf's third column is
     gone too; every one of its test ids is on this card.

     Watching keeps it: reading the board is the whole activity of a game nobody
     is playing, and the engine hands back no controls for a piece that is not
     yours, so nothing here needs to know about the seat. */
  if (inspector === null) return null;
  // Nothing is standing there, so the ground is the subject.
  if (inspector.kind === "ground") return <GroundCard card={inspector} />;
  return <Inspector card={inspector} choose={(option) => session.choose(option)} />;
}
